import { getDistanceFromCityCenterOptions } from "@Pages/Search/components/FilterSection/data/filtersList";
import RadioChip from "../../../FilterSubsection/components/RadioChip";
import styles from "./distanceFromCityCenter2.module.scss";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";

const DistanceFromCityCenter = ({ value: selectedValue = "", dispatch }: any) => {
  const handleSelectedValue = (val = "") => {
    gtagEventEmitter({
      action: "SP_filter_subsection_filter2_value_selected",
      category: "SP_filter_subsection2",
      value: "Distance from city center",
    });
    dispatch({ type: "region_radius", payload: val });
  };
  const { t } = useTranslationHook();

  const currentSelectedValue = selectedValue || "";

  const distanceFromCityCenterOptions = getDistanceFromCityCenterOptions(t);

  return (
    <div className={styles.distanceContainer}>
      {distanceFromCityCenterOptions.map(({ label, value }) => (
        <RadioChip
          name="name"
          label={label}
          value={value}
          isSelected={currentSelectedValue === value}
          key={value}
          setSelectedValue={() => handleSelectedValue(value)}
        />
      ))}
    </div>
  );
};

export default wrapperHOC(DistanceFromCityCenter, {
  componentName: "DistanceFromCityCenter-FilterSubsection2-SearchListDesktop-SearchPage",
  showForChina: true,
});
